import { render } from "./KnowledgeBase.vue?vue&type=template&id=72c4ed2d&scoped=true&lang=pug"
import script from "./KnowledgeBase.js?vue&type=script&lang=js&external"
export * from "./KnowledgeBase.js?vue&type=script&lang=js&external"

import "./KnowledgeBase.vue?vue&type=style&index=0&id=72c4ed2d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c4ed2d"]])

export default __exports__